import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface CurrencyInputProps extends Omit<TextFieldProps, 'onChange'> {
  value: number | '';
  onChange: (value: number) => void;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({ value, onChange, ...props }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    
    // Remove all non-digit characters except decimal point
    const numericValue = inputValue.replace(/[^0-9.]/g, '');
    
    // Convert to number, defaulting to 0 if empty
    const numberValue = numericValue === '' ? 0 : Number(numericValue);
    
    onChange(numberValue);
  };

  // Format the value for display with commas
  const displayValue = value === '' ? '' : 
    value.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

  return (
    <TextField
      {...props}
      value={displayValue}
      onChange={handleChange}
      InputProps={{
        ...props.InputProps,
        startAdornment: '$ ',
      }}
    />
  );
};

export default CurrencyInput; 